<script setup>
const lang = ref(navigator.language ?? `en`);
const {locale} = useI18n();
const configStore = useConfigStore();

onMounted(()=> {
  (lang.value.split('-')[0] === `el`) ? locale.value = `el` : locale.value = `en`;
})
</script>

<template>
  <div class="flex flex-col h-screen cursor-default">
    <Header  class="bg-eggplant-980/85 backdrop-blur-lg  z-50 fixed w-screen top-0 py-4 max-sm:px-4 max-md:px-16 max-lg:px-28 px-32 "/>
    <Transition enter-from-class="scale-0" enter-active-class="transition-all duration-500 ease-in" leave-to-class="scale-0" leave-active-class="transition-all duration-500 ease-out"  appear appear-active-class="transition-all duration-500 ease-in">
      <Toast v-if="configStore.showToast" class="self-center top-24 z-40 absolute bg-eggplant-800 text-white "/>
    </Transition>

    <Menu class="bg-eggplant-980/85 backdrop-blur-lg fixed top-20 lg:hidden h-screen z-50 transition duration-500 ease-in w-screen"  :class="(configStore.openMenu) ? `translate-x-0` : `translate-x-full h-0`" />

    <div class="bg-transparent grow mt-24  max-sm:px-4 max-lg:px-16 px-24 my-4">
      <Suspense>
        <template #default>
          <RouterView />
        </template>
        <template #fallback>
          Loading...
        </template>
      </Suspense>
    </div>

    <Footer class="z-50"/>
  </div>
</template>
